import { render, staticRenderFns } from "./OrderProductsTable.vue?vue&type=template&id=331d2172&lang=pug&"
import script from "./OrderProductsTable.vue?vue&type=script&lang=ts&"
export * from "./OrderProductsTable.vue?vue&type=script&lang=ts&"
import style0 from "./OrderProductsTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports